import React from 'react';
import TemperatureGraph from './TemperatureGraph';
import './CameraCard.css';

const CameraCard = ({ camera, index }) => {
  if (!camera) {
    return <div className="camera-card error">Ошибка: данные камеры отсутствуют</div>;
  }

  const {
    name,
    temperature,
    humidity,
    light,
    status,
    tempRange,
    humidityRange,
    lightRange,
    tempDisplay,
    humidityDisplay,
    lightDisplay,
    showTemperatureGraph,
    id: cameraId
  } = camera;

  const isOutOfRange = (value, range) => {
    if (value === null || value === undefined) return false;
    return value < range.min || value > range.max;
  };

  const getProgressBounds = (range) => {
    const min = range?.min ?? 0;
    const max = range?.max ?? 100;
    return { min: min * 0.2, max: max * 1.2 };
  };

  const calculateFillPercent = (value, range) => {
    if (value === null || value === undefined) return 0;
    const { min, max } = getProgressBounds(range);
    const percent = ((value - min) / (max - min)) * 100;
    return Math.min(100, Math.max(0, percent));
  };

  const isAlarmForParam = (value, range) => {
    if (value === null || value === undefined) return true;
    return value < range.min || value > range.max;
  };

  const renderDigits = (label, value, range, unit) => {
    if (value === null) return null;
    const outOfRange = isOutOfRange(value, range);
    return (
      <div className="sensor">
        <span className="sensor-label">{label}</span>
        <span className={`sensor-value ${outOfRange ? 'out-of-range' : ''}`}>
          {value !== null ? `${value.toFixed(2)} ${unit}` : '—'}
        </span>
        <span className="sensor-range">
          Норма: {range?.min ?? '?'}~{range?.max ?? '?'} {unit}
        </span>
      </div>
    );
  };

  const renderProgressBar = (label, value, range, unit) => {
    if (value === null) return null;
    const outOfRange = isAlarmForParam(value, range);
    const fillPercent = calculateFillPercent(value, range);
    const bounds = range ? `${range.min}…${range.max} ${unit}` : '—';
    return (
      <div className="sensor progress-sensor">
        <div className="sensor-header">
          <span className="sensor-label">{label}</span>
          {/* 
                    <span className={`sensor-value ${outOfRange ? 'out-of-range' : ''}`}>
            {value !== null ? `${value} ${unit}` : '—'}
          </span>
          */}

        </div>
        <div className="progress-bar-container">
          <div
            className={`progress-bar-fill ${outOfRange ? 'alarm-fill' : ''}`}
            style={{ width: `${fillPercent}%` }}
          />
        </div>
        <div className="sensor-range">Норма: {bounds}</div>
      </div>
    );
  };

  const renderParameter = (label, value, range, unit, display) => {
    if (display === 'hidden') return null;
    if (display === 'progressbars') return renderProgressBar(label, value, range, unit);
    return renderDigits(label, value, range, unit);
  };

  const cardClass = `camera-card ${status === 'alarm' ? 'alarm' : 'ok'}`;
//<div className="camera-id">CAM-{100 + index}</div>
  return (
    <div className={cardClass}>
      <h3>{name}</h3>
      
      {renderParameter('Темп.', temperature, tempRange, '°C', tempDisplay)}
      {renderParameter('Влаж.', humidity, humidityRange, '%', humidityDisplay)}
      {renderParameter('Свет', light, lightRange, 'lx', lightDisplay)}
      
      {showTemperatureGraph && (
        <div className="graph-container">
          <TemperatureGraph 
            cameraId={cameraId} 
            minTemp={tempRange?.min} 
            maxTemp={tempRange?.max} 
          />
        </div>
      )}
    </div>
  );
};

export default CameraCard;